import React, { useEffect } from 'react'; 
import { Link } from 'react-router-dom';
import Header from'../Component/Header'
const SchoolUniform = () => { 
    useEffect(() => {
        document.title = ' School Uniform - St. Josephs School Quadian Punjab';  
    }, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                  <li>Academic</li>
                 <li>School Uniform</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2>School Uniform</h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                     <div class="table-responsive maintable">
                        <table class="table">
                            <tbody>
                            <tr>
                            <td className="tablebg1" colspan="2"> kindergarten </td> 
                            </tr> 
                            <tr> 
                            <td className="tablebg2" colspan="2"> Summer </td>
                            </tr> 
                            <tr>
                            <td> <b>Boys:</b> Skin shirt, Dark brown check shorts, With bow and belt, Skin socks with scholl name (S.J.C.S)  </td>
                            <td> <b>Girls:</b> Skin shirt, Dark brown check Skirt, With Bow and Belt, Skin Socks with school name (S.J.C.S) </td>
                            </tr>
                            <tr> 
                            <td className="tablebg1" colspan="2"> Winter </td>
                            </tr>
                            <tr> 
                            <td> <b> Boys:</b> White shirt with red cuffs, Grey pants with red lines, Grey socks. Tie red and grey, Red sweater and blazer </td>
                            <td> <b>Girls:</b> White shirt with red cuffs, Grey skirt with red lines, Grey socks Tie (red+grey), Red sweater and blazer </td>
                            </tr>
                            <tr> 
                            <td className="tablebg2" colspan="2"> Class I-X </td>
                            </tr>
                            <tr>
                            <td colspan="2"> <b>Summer</b> Small Check White + Blue combination Shirt, Blue Pant for Males, Skirt for Females, White Socks, Neck Tie Belt (Blue+White combination) </td>
                            </tr>
                            <tr>
                            <td colspan="2"> <b>Winter</b> White shirt with Mehroon cuffs, Grey pants with red lines, Grey Socks, Grey Belt, Neck Tie (Red + Grey combination), Red Sweater + Blazer</td>
                            </tr>
                            <tr> 
                            <td className="tablebg1" colspan="2"> (P. T. Uniform for Classes: I -X)</td> 
                            </tr>
                            <tr>  
                            <td className="tablebg2" colspan="2"> Summer </td>
                            </tr>
                            <tr>
                            <td> Boys: House T-Shirts, White Pants, White Nicker For 1st & 2nd Classes) White Socks, White Shoes Without Heels, School Belt and Tie White Patka for Sikh Boys) </td> 
                            
                            <td> Girls: House T-Shirts Shirt, White Skirts (Divided) White Socks, White Shoes Without Heels, School Belt and Tie, White Ribbon </td>
                            </tr>
                            <tr> 
                            <td className="tablebg2" colspan="2"> Winter </td>
                            </tr>
                            <tr>
                            <td> <b>Boys:</b> White Full sleeved Shirt, White Pants, White Socks, White Shoes Without Heels, School Belt and Tie White Patka for Sikh Bovs) Red Pullover & Red Coat </td>
                            <td> <b>Girls: </b> White Full sleeved Shirt, White Skirts (Divided) White Socks, White Shoes Without Heels, School Belt and Tie, White Ribbon, Red Pullovers & Red Coat, White Socks. </td>
                            </tr>
                            </tbody>
                           </table>
                        </div> 
                    </div>
                </div>
                 
            </div>
        </div>
     </>
  )
}

export default SchoolUniform

